import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const AuditPage = lazy(() => import('./AuditPage'));

const routes: RouteObject[] = [{ path: '/audit', element: <Guard any={['audit.read']}><AuditPage /></Guard> }];
export default routes;
